// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-layout .nkl-popover {
  width: 275px;
  padding-top: 0;
}
.nkl-layout .nkl-popover .nkl-popover-inner {
  margin-left: 6px;
  margin-bottom: 6px;
  border-radius: 4px;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}
.nkl-layout .main-content {
  padding-top: 0px;
}
.nkl-layout .main-content a {
  color: #1a73e8;
  background-color: transparent;
  text-decoration: none;
}
.nkl-layout .main-content a:visited {
  color: #1a73e8;
  background-color: transparent;
  text-decoration: none;
}
.nkl-layout .main-content a:hover {
  color: #1a73e8;
  background-color: transparent;
  text-decoration: underline;
}
.nkl-layout .nkl-btn {
  border-radius: 6px;
  background-color: #1a73e8;
  border-color: #1a73e8;
}
.nkl-layout .nkl-btn:hover,
.nkl-layout .nkl-btn:active,
.nkl-layout .nkl-btn:focus {
  background-color: #1a73e8;
  border-color: #1a73e8;
  color: #fff;
}
.nkl-layout .nkl-btn:disabled {
  color: #bcc0c4;
  background-color: #e4e6ea;
}
.nkl-layout .nkl-btn:disabled:hover,
.nkl-layout .nkl-btn:disabled:active,
.nkl-layout .nkl-btn:disabled:focus {
  border-color: #e4e6ea;
}
.nkl-layout .nkl-checkbox-input,
.nkl-layout .nkl-checkbox-inner {
  border-color: #1a73e8 !important;
}
.nkl-layout .nkl-checkbox-checked .nkl-checkbox-inner {
  background-color: #1a73e8;
}
.nkl-layout .ecard-drawer .back-btn,
.nkl-layout .upload-drawer .back-btn {
  background-color: #1a73e8;
  border-color: #1a73e8;
}
.nkl-layout .ecard-drawer .ecard-back,
.nkl-layout .upload-drawer .ecard-back {
  background-color: #1a73e8;
}
.nkl-layout .ecard-drawer .upload-content,
.nkl-layout .upload-drawer .upload-content {
  border-radius: 4px;
}
.nkl-layout .success-container .message {
  color: #1a73e8;
}
.nkl-layout .success-icon {
  color: #1a73e8;
}
.nkl-layout .bubble {
  background: #f0f2f5;
  border-color: #e4e6eb;
}
.nkl-layout .header-menu-container {
  margin-left: auto;
}
.nkl-layout .header-menu-container .nkl-popover-inner-content {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}
.recognize .anticon svg {
  fill: #1a73e8;
}
.recognize .bread-crumb-container .nkl-popover .nkl-popover-inner {
  border-radius: 4px;
}
.recognize .back-button {
  background-color: transparent;
  border-color: #1a73e8;
  color: #1a73e8;
}
.recognize .back-button:hover,
.recognize .back-button:active,
.recognize .back-button:focus {
  background-color: transparent;
  border-color: #1a73e8;
  color: #1a73e8;
}
.recognize .search-container .search-input.nkl-input-affix-wrapper-focused,
.recognize .search-container .search-input .nkl-input-affix-wrapper:focus {
  border-bottom-color: #1a73e8;
}
.recognize .search-container .nkl-popover .nkl-popover-inner {
  border-radius: 4px;
}
.recognize .program-list .program-item .program-top-card .program-select .anticon svg {
  fill: #1a73e8;
}
.recognize .program-list .program-item .program-top-card .program-select .nkl-spin-dot-item {
  background-color: #1a73e8;
}
.recognize .program-list .program-item .program-bottom-card .error-item {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.recognize .program-list .program-item-selected {
  border-color: #1a73e8;
  border-radius: 4px;
}
.recognize .behavior-section .behavior-select-container .behavior-select:hover,
.recognize .behavior-section .behavior-select-container .behavior-select:active,
.recognize .behavior-section .behavior-select-container .behavior-select:focus {
  border-color: #1a73e8;
}
.recognize .awards-container .budget-meter-container .nkl-progress-bg {
  background-color: #1a73e8;
}
.recognize .awards-container .allocate-points .nkl-checkbox-inner {
  border-color: #1a73e8;
}
.recognize .awards-container .allocate-points .nkl-checkbox-checked .nkl-checkbox-inner {
  background-color: #1a73e8;
}
.recognize .awards-container .points-container .points:hover,
.recognize .awards-container .points-container .points:active,
.recognize .awards-container .points-container .points:focus {
  border-color: #1a73e8;
}
.recognize .message-container .nkl-input:hover,
.recognize .message-container .nkl-input:active,
.recognize .message-container .nkl-input:focus {
  border-bottom-color: #1a73e8;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
